import Section, {html, css} from './_section'

customElements.define('steens-form-section-guardian', class extends Section{

    get title(){ return '🏠 Parent / Guardian' }

    // static get styles(){return css`
    //     :host {
    //         display: block;
    //         position:relative;
    //     }
    // `}

    renderControls(){return html`
        <div class="grid-2">

            <form-control material="filled" key="parent_name" label="Name">
                <input slot="control" type="text" autocomplete="section-parent name">
            </form-control>
            
            <form-control material="filled" autocomplete="section-parent email" key="parent_email" label="Parent Email">
                <input slot="control" type="email" autocomplete="email">
            </form-control>

            <form-control material="filled" key="parent_phone_home" label="Phone (home)">
                <input slot="control" type="tel" autocomplete="section-parent home tel">
            </form-control>

            <form-control material="filled" key="parent_phone_cell" label="Phone (cell/business)">
                <input slot="control" type="tel" autocomplete="section-parent cell tel">
            </form-control>

        </div>

        <b-hr short></b-hr>
        
        <check-box key="different_address" type="switch" label="Different address than camper"></check-box>

        <section>
            <br>
            <div class="address">
                
                <form-control material="filled" key="parent_address" label="Address">
                    <input slot="control" type="text" autocomplete="section-parent address-line1">
                </form-control>
                
                <form-control material="filled" key="parent_city" label="City">
                    <input slot="control" type="text" autocomplete="section-parent address-level2">
                </form-control>
                
                <form-control material="filled" key="parent_state" label="State">
                    <input slot="control" type="text" autocomplete="section-parent address-level1">
                </form-control>
                
                <form-control material="filled" key="parent_zip" label="Zip">
                    <input slot="control" type="number" autocomplete="section-parent postal-code">
                </form-control>
                
            </div>
        </section>
    `}

})